import React, { Component } from 'react';
import StoryCard, { variations } from './StoryCard';

export default class WideStoryCard extends Component {
  render() {
    return (
      <StoryCard
        {...this.props}
        variation={variations.WIDER_ASSET}
      />
    );
  }
}
